import type { BrandThemeConfig } from "./types";

export function applyBrandTheme(
  theme: BrandThemeConfig | undefined,
  root = document.documentElement
) {
  if (!theme) {
    return;
  }

  for (const [name, value] of Object.entries(theme)) {
    if (value) {
      root.style.setProperty(`--${name}`, value);
    }
  }
}
